import { AfterContentInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { ListingPropertyGQL, ListingPropertyQuery, ListingQuery } from '../../../../../../graphql'
import { ListingDocumentsComponent } from '../shared/listing-documents/listing-documents'
import { MatDialog } from '@angular/material/dialog'
import { Amplitude } from '../../../../../injectable'
import { GalleryComponent } from '../../../../shared-member/organism/gallery/gallery'
import { UnsubscribeOnDestroy } from '../../../../../utility'
import { dialogWidth } from '../../../../../constant'

@Component({
    selector: 'app-listing-property',
    styleUrls: ['listing-property.scss'],
    templateUrl: 'listing-property.html'
})
export class ListingPropertyComponent extends UnsubscribeOnDestroy implements AfterContentInit {

    @Input() listing: ListingQuery['listing']

    property: ListingPropertyQuery['property']
    showFeatures: boolean
    hasDocuments = false

    @Output() onPropertyLoad = new EventEmitter<ListingPropertyQuery['property']>()

    @ViewChild('description', ) el: ElementRef<HTMLElement>

    constructor(private _amplitude: Amplitude,
                private _dialog: MatDialog,
                private _listingPropertyGQL: ListingPropertyGQL) {
        super()
    }

    // Public
    ngAfterContentInit() {
        this.hasDocuments = this.checkIfHasDocuments()
        this.showFeatures = !!this.listing.summary.highlightedFeatures.features?.length
        this.requestProperty()
    }

    checkOverflow(element) {
        return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth
    }

    showFullDescription(element: HTMLElement) {
        this._amplitude.logEvent('Listing Read More Clicked', {
            listingId: this.listing?.listingId
        })

        element.classList.remove('line-clamp')
    }

    viewPhotos(photos) {
        this._dialog.open(GalleryComponent, {
            data: {
                subjectId: this.listing?.listingId,
                photos: photos
            },
            panelClass: 'gallery-dialog',
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%'
        })
    }

    viewDocuments() {
        this._dialog.open(ListingDocumentsComponent, {
            data: {
                documents: this.listing?.documentLibrary?.categories
            },
            width: dialogWidth.md,
            height: '70%',
            maxHeight: '100vh'
        })
    }

    checkIfHasDocuments() {
        const categories = this.listing?.documentLibrary?.categories
        let hasDocs = false
        if (categories && categories.length > 1) {
            for (const category of categories) {
                if (category?.documents?.length) {
                    hasDocs = true
                    break;
                }
            }
        } 
        return hasDocs
    }

    private requestProperty() {
        this._subscriptions.push(this._listingPropertyGQL
            .watch({ propertyId: this.listing.asset.assetId }, { fetchPolicy: 'no-cache' })
            .valueChanges
            .subscribe(result => {
                if (!result.loading) {
                    this.property = result.data.property
                    this.onPropertyLoad.emit(this.property)
                }
            }))
    }
}
